import React, { Component } from "react";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";
import { sendService } from "./../../Services/service";
// import Button from "@material-ui/core/Button";
import "./../changePasswordContainer.css";


class ModificateUserComponent extends Component {
  state = {
    form: {},
    roles: []
  };
  handlerChange = (variable, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value
      }
    })
  }

  handlerSubmit = () => {
    if(this.state.form.roles.length === 0){
      window.alert('Se requiere asignar al menos un rol')
      return
    }
    this.props.onSubmit(this.state.form)
  };

  async componentDidMount() {
    const roles = await sendService('/api/v1/users/getRoles', 'GET')
    const form = {
      id: this.props.user.id,
      nombres: this.props.user.nombres,
      apellidos: this.props.user.apellidos,
      tipoDocumento: this.props.user.tipoDocumento,
      numeroDocumento: this.props.user.numeroDocumento,
      cargo: this.props.user.cargo,
      dependencia: this.props.user.dependencia,
      nombreAutorizaRegistro: this.props.user.nombreAutorizaRegistro,
      roles: this.props.permitions.map(r => r.id)
    }
    this.setState({ form, roles: roles.status === 200 ? roles.response : [] })
  }

  onCancel = () => {
    console.log('cancel')
  }

  render() {
    return (
      <>
        <div>
          <h1 className="page-title">{LANDING_MENU_BAR.MODIFICATE_USER}</h1>
        </div>
        <div className="background-image">
          <div className="background-body">
            <div className="container-content">
              <div className="content-line white-bg">
                <Form
                  onChange={this.handlerChange}
                  objectCreator={[
                    {
                      type: formTypes.text,
                      classContainer: "line line-33",
                      classLabel: "input-text",
                      label: "Nombre(s)",
                      placeholder: "Ingrese su(s) nombre(s)",
                      required: true,
                      variable: "nombres",
                      value: this.props.user.nombres
                    },
                    {
                      type: formTypes.text,
                      classContainer: "line line-33",
                      classLabel: "input-text",
                      label: "Apellidos",
                      placeholder: "Ingrese sus apellidos",
                      required: true,
                      variable: "apellidos",
                      value: this.props.user.apellidos
                    },
                    {
                      type: formTypes.text,
                      classContainer: "line line-33",
                      classLabel: "input-text",
                      label: "Cargo",
                      placeholder: "Ingrese el cargo del usuario",
                      required: true,
                      variable: "cargo",
                      value: this.props.user.cargo
                    },
                    {
                      type: formTypes.select,
                      label: "Tipo de documento",
                      required: true,
                      classContainer: "line line-33",
                      classLabel: "input-text",
                      variable: "tipoDocumento",
                      keyValue: "value",
                      keyText: "text",
                      data: [
                        { value: "Contraseña", text: "Contraseña" },
                        {
                          value: "Cédula de ciudadanía",
                          text: "Cédula de ciudadanía"
                        },
                        {
                          value: "Tarjeta de identidad",
                          text: "Tarjeta de identidad"
                        },
                        {
                          value: "Cedula de extranjería",
                          text: "Cedula de extranjería"
                        },
                        { value: "Pasaporte", text: "Pasaporte" }
                      ],
                      value: this.props.user.tipoDocumento
                    },
                    {
                      type: formTypes.text,
                      classContainer: "line line-33",
                      classLabel: "input-text",
                      label: "Número de documento",
                      placeholder: "Ingrese número de documento",
                      required: true,
                      variable: "numeroDocumento",
                      value: this.props.user.numeroDocumento
                    },
                    {
                      type: formTypes.text,
                      classContainer: "line line-33",
                      classLabel: "input-text",
                      label: "Dependencia",
                      placeholder: "Ingrese dependencia",
                      required: true,
                      variable: "dependencia",
                      value: this.props.user.dependencia
                    },
                    {
                      type: formTypes.checkbox,
                      classContainer: "line line-100",
                      classInput: "secondary-color",
                      classLabel: "input-text line line-33",
                      checkMark: "checkmark",
                      data: this.state.roles,
                      keyText: "rol",
                      keyValue: "id",
                      label: "Rol(es) asignado(s)",
                      required: true,
                      variable: "roles",
                      // value: []
                      value: []
                    },

                    {
                      type: formTypes.div,
                      classContainer: "line line-40"
                    },
                    {
                      type: formTypes.submit,
                      classContainer:
                        "button-primary line line-10 text-center",

                      label: "Guardar",
                      placeholder: "-"
                    },
                    {
                      type: formTypes.buttonclick,
                      classContainer:
                        "button-secondary line line-10 text-center",
                      label: "Cancelar",
                      placeholder: "-",
                      onClick: this.props.onCancel
                    },
                    {
                      type: formTypes.div,
                      classContainer: "line line-40"
                    }
                  ]}
                  onSubmit={this.handlerSubmit}
                  values={this.state.form}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ModificateUserComponent
